import { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Helmet } from 'react-helmet-async';
import axiosInstance from '../axiosConfig';
import './Checkout.css';

const stripePromise = loadStripe(
  'pk_live_51Qm0eHI8JCfI67oE7e3bqBczfL2J9baolWACViRaig56iiut9p31IN5OJS0mwTe6bLJdsTmZuFpiJ7U7EJpTR3uO00CR2qge06'
);

const Checkout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const billingCycle = 'annual';

  // Lock scroll while on checkout + ensure we start at the top
  useEffect(() => {
    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    window.scrollTo(0, 0);

    return () => {
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, []);

  const handleCheckout = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axiosInstance.post(
        '/create-checkout-session/',
        { billing_cycle: billingCycle },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('Checkout session created:', response.data);

      const stripe = await stripePromise;
      if (!stripe) {
        throw new Error('Stripe failed to initialize');
      }

      const { error } = await stripe.redirectToCheckout({
        sessionId: response.data.id,
      });

      if (error) {
        setError(error.message);
      }
    } catch (error) {
      console.error('Checkout error:', error);
      setError(
        error.response?.data?.error || 'Error. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="co-page">
      <Helmet>
        <title>Checkout — PrivateIQ</title>
        <meta name="description" content="Complete your PrivateIQ membership." />
        <meta name="theme-color" content="#2c5c4f" />
      </Helmet>

      <div className="co-card">
        {/* Close / back icon */}
        <button
          className="co-close"
          onClick={() => (window.location.href = '/')}
          aria-label="Close"
        >
          ×
        </button>

        <div className="co-badge">Membership</div>
        <h1 className="co-title">Yearly Membership</h1>
        <p className="co-subtitle">Best for serious club research.</p>

        {/* Pricing */}
        <div className="co-pricing">
          <span className="co-price">$20</span>
          <span className="co-price-detail">/ year</span>
        </div>

        {/* Benefits */}
        <ul className="co-benefits">
          <li>Full access to 2,500+ private club profiles</li>
          <li>Shared intel on cost estimates</li>
          <li>Member community, message boards &amp; round sharing</li>
          <li>Exclusive discounts with select golf brands</li>
        </ul>

        {/* CTA */}
        <button
          onClick={handleCheckout}
          disabled={loading}
          className="co-btn"
        >
          {loading ? 'Processing…' : 'Get full access for $20/year'}
        </button>

        <p className="co-microcopy">Cancel anytime. No ads.</p>

        {/* Legal links */}
        <div className="co-legal-row">
          <button
            type="button"
            className="co-legal-link"
            onClick={() => (window.location.href = '/termsofservice')}
          >
            Terms
          </button>
          <span className="co-legal-sep">·</span>
          <button
            type="button"
            className="co-legal-link"
            onClick={() => (window.location.href = '/privacypolicy')}
          >
            Privacy
          </button>
        </div>

        {error && <div className="co-error">{error}</div>}
      </div>
    </div>
  );
};

export default Checkout;
